import { demoPeopleRows, type PeopleSheet } from '@lg/shared';

/**
 * Sample people files (spec 17 fixtures). Each is the valid demo staffing with
 * one deliberate problem, so a demo can show the rule firing and the fix.
 */
export const SAMPLE_VARIANTS = [
  { id: 'valid', label: 'Valid venue staffing', file: 'people-valid.xlsx' },
  { id: 'missing-manager', label: 'Missing manager (P3 error)', file: 'people-missing-manager.xlsx' },
  { id: 'no-limit', label: 'Missing approval limit (P5 error)', file: 'people-no-limit.xlsx' },
  { id: 'coverage-gap', label: 'Routing coverage gap (P8 error)', file: 'people-coverage-gap.xlsx' },
] as const;
export type SampleVariant = (typeof SAMPLE_VARIANTS)[number]['id'];

export interface SampleRow {
  sheet: PeopleSheet;
  data: Record<string, unknown>;
}

export function samplePeopleRows(variant: SampleVariant, companyId: string, asOf: Date): SampleRow[] {
  const rows: SampleRow[] = demoPeopleRows(companyId, asOf).map((r) => ({
    sheet: r.sheet,
    data: { ...r.data },
  }));
  switch (variant) {
    case 'valid':
      return rows;
    case 'missing-manager':
      // The buyer reports to a finance position that was never created.
      return rows.map((r) =>
        r.sheet === 'positions' && r.data['positionId'] === `${companyId}-BUY`
          ? { ...r, data: { ...r.data, reportsToPositionId: `${companyId}-FIN` } }
          : r,
      );
    case 'no-limit':
      return rows.filter((r) => !(r.sheet === 'approvalLimits' && r.data['jobId'] === 'PROJ-MGR'));
    case 'coverage-gap':
      // Nobody holds the GL approver role, so journals cannot be approved.
      return rows.filter((r) => !(r.sheet === 'roles' && r.data['roleId'] === 'LEDGERACCOUNTINGMANAGER'));
  }
}
